import AddressEditor from "websiteUsers/AddressEditor";
import EventEmitter from "base/EventEmitter";

/**
 * @property addresses AddressEditor[]
 * @property removedAddresses AddressEditor[]
 * @property user object
 * @property _user object
 */
class AddressesEditor extends EventEmitter {
    constructor(data = [], user = null) {
        super();
        this._user = user;

        this.addresses = [];
        this.removedAddresses = [];

        this.buildElement();
        this.bindEvents();
        this.processData(data);
        if (this.addresses.length > 0) {
            this.showAddress(this.addresses[0]);
        }

        this.updateList();
    }

    get user() {
        return this._user;
    }

    set user(user) {
        this._user = user;

        this.addresses.forEach((address) => address.user = user);
    }

    processData(data) {
        data.map((addressData) => new AddressEditor(addressData, this.user)).map(this._addAddress.bind(this));
    }

    getAddAddressBtn() {
        return eotwJSXFactory('button', {class: "admin-btn admin-btn--confirm admin-btn--address js-add-address"}, ["Add Address"]);
    }

    updateList() {
        this.$list.html(
            this.addresses.map((address) => address.getListItem()).concat([this.getAddAddressBtn()])
        );
    }

    buildElement() {
        this.$list = (
            eotwJSXFactory('div', {class: "admin-address-list"}
            )
        );

        this.$addresses = eotwJSXFactory('div', {class: "admin-form__col admin-form__col--flex admin-form__col--address-form"});


        this.$element = (
            eotwJSXFactory('div', {class: "admin-form__col admin-form__col--flex"}, [
                eotwJSXFactory('div', {class: "admin-form__col admin-form__col--address"}, [
                    this.$list
                ]),
                this.$addresses
            ])
        );
    }

    bindEvents() {
        const me = this;
        this.$list.on("click", ".js-add-address", () => {
            this.addAddress();
            return false;
        }).on("click", ".js-select-address", function () {
            me.showAddress($(this).data("address"));
            return false;
        }).on("click", ".js-remove-address", function () {
            me.removeAddress($(this).parents(".js-select-address").data("address"));
            return false;
        });

    }

    showAddress(address) {
        $.each(this.addresses, (_, _address) => {
            _address.$element.hide();
            _address.getListItem().removeClass("admin-address-list__item--active")
        });
        address.$element.show();
        address.getListItem().addClass("admin-address-list__item--active")
    }

    /**
     * @param address AddressEditor
     */
    _addAddress(address) {
        address.on("submit", () => this.emit("submit")).on("defaultBilling", () => {
            $.each(this.addresses, (_, otherAddress) => {
                if (otherAddress !== address) {
                    otherAddress.$element.find("input[name='isDefaultBilling']").prop("checked", false).change();
                }
            })
        });
        this.addresses.push(address);
        this.$addresses.append(address.$element);
    }

    addAddress() {
        let address = new AddressEditor(null, this.user);
        this._addAddress(address);
        this.updateList();
        this.showAddress(address)
    }

    /**
     * @param address AddressEditor
     */
    removeAddress(address) {
        this.addresses = this.addresses.filter((other) => address !== other);

        if (this.addresses.length > 0 && address.$element.is(":visible")) {
            this.showAddress(this.addresses[0]);
        }
        address.$element.remove();
        if (address.exists) {
            this.removedAddresses.push(address);
        }
        this.updateList();
    }

    save() {
        return Promise.all(this.addresses.map((address) => address.save()).concat(this.removedAddresses.map((address) => address._delete()))).then(() => this.removedAddresses = []);
    }

    validate() {
        let result = true;
        $.each(this.addresses, (_, address) => {
            if (result === false) return;

            result = address.validate();

            if (result === false) this.showAddress(address);
        });
        return result;
    }
}


export default AddressesEditor;
